export enum SimpleListType {
  Contact = 'contact-list',
  Download = 'download-list',
  Link = 'link-list',
}
